import { render, staticRenderFns } from "./TopProducts.vue?vue&type=template&id=7eb1f9fe&scoped=true&"
import script from "./TopProducts.vue?vue&type=script&lang=js&"
export * from "./TopProducts.vue?vue&type=script&lang=js&"
import style0 from "./TopProducts.vue?vue&type=style&index=0&id=7eb1f9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb1f9fe",
  null
  
)

export default component.exports